import type { EvidenceActivityEvent } from "../../types/evidenceActivity";
import { SLOW_GAP_SECONDS } from "../../types/evidenceActivity";

const FOLDABLE = new Set(["field_edited", "section_toggled", "fact_toggled", "screenshot_added", "screenshot_removed"]);

const EDIT_WORDS: Record<string, [string, string]> = {
  field_edited: ["field", "fields"],
  section_toggled: ["section", "sections"],
  fact_toggled: ["fact", "facts"],
  screenshot_added: ["screenshot added", "screenshots added"],
  screenshot_removed: ["screenshot removed", "screenshots removed"],
};

export type TrailRow =
  | { kind: "event"; event: EvidenceActivityEvent }
  | { kind: "group"; events: EvidenceActivityEvent[]; gapSeconds: number; counted: boolean; slow: boolean };

/** Two or more edits in a row become one group; a lone edit and every other step stay as they are. */
export function foldSession(events: EvidenceActivityEvent[]): TrailRow[] {
  const rows: TrailRow[] = [];
  let run: EvidenceActivityEvent[] = [];
  const flush = () => {
    if (run.length > 1) {
      const counted = run.filter((e) => e.counted);
      rows.push({ kind: "group", events: run, gapSeconds: counted.reduce((sum, e) => sum + (e.gapSeconds ?? 0), 0), counted: counted.length > 0, slow: counted.some((e) => (e.gapSeconds ?? 0) >= SLOW_GAP_SECONDS) });
    } else if (run.length === 1) rows.push({ kind: "event", event: run[0] });
    run = [];
  };
  for (const event of events) {
    if (FOLDABLE.has(event.step)) { run.push(event); continue; }
    flush();
    rows.push({ kind: "event", event });
  }
  flush();
  return rows;
}

/** "3 fields · 2 sections · 1 screenshot added" */
export function groupDetail(events: EvidenceActivityEvent[]): string {
  return Object.entries(EDIT_WORDS)
    .map(([step, [one, many]]) => {
      const n = events.filter((e) => e.step === step).length;
      return n ? `${n} ${n === 1 ? one : many}` : null;
    })
    .filter(Boolean)
    .join(" · ");
}
